import { request } from '@/utils/request'

export const userApi = {
  adminLogin: '/api/admin/login',
  Logout: '/auth/logout',
  ForgePassword: '/auth/forge-password',
  Register: '/auth/register',
  twoStepCode: '/auth/2step-code',
  SendSms: '/account/sms',
  SendSmsErr: '/account/sms_err',
  // get my info
  UserInfo: '/user/info',
  UserMenu: '/user/nav',
  codeSrc: '/api/auth/captcha',
  registerUser: '/api/auth/accountActivation',
  schoolPermission: '/api/school/permission',
  loginDing: '/api/oauth/login'
}

/**
 * login func
 * parameter: {
 *     username: '',
 *     password: '',
 *     remember_me: true,
 *     captcha: '12345'
 * }
 * @param parameter
 * @returns {*}
 */

export function login (parameter) {
  return request({
    url: userApi.Login,
    method: 'post',
    data: parameter
  })
}

export function loginDing (parameter) {
  return request({
    url: userApi.loginDing,
    method: 'post',
    data: parameter
  })
}

export function registerUser (parameter) {
  return request({
    url: userApi.registerUser,
    method: 'post',
    data: parameter
  })
}

export function getInfo () {
  return request({
    url: userApi.UserInfo,
    method: 'get',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}

export function getCurrentUserNav () {
  return request({
    url: userApi.UserMenu,
    method: 'get'
  })
}

export function logout () {
  return request({
    url: userApi.Logout,
    method: 'post',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}

export function schoolPermission() {
  return request({
    url: userApi.schoolPermission,
    method: 'get'
  })
}
/**
 * get user 2step code open?
 * @param parameter {*}
 */
export function get2step (parameter) {
  return request({
    url: userApi.twoStepCode,
    method: 'post',
    data: parameter
  })
}

const filter = function (params, back) {
  return new Promise((resolve, reject) => {
    return request(params, (res) => {
      back && back(res)
    }).then(response => {
      if (response && response.code === 200) {
        return resolve(response)
      } else {
        return reject(response)
      }
    }, err => {
      reject(err)
    })
  })
}

export function adminLogin (parameter) {
  return request({
    url: userApi.adminLogin,
    method: 'post',
    data: parameter
  })
}
